import { render, staticRenderFns } from "./Sparkles.vue?vue&type=template&id=3d365bcb&"
import script from "./Sparkles.vue?vue&type=script&lang=ts&"
export * from "./Sparkles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports